import { _ as s } from "./atoms-v21176.js";
import { i as r } from "./atoms-v21177.js";
var a = s, t = r, i = "[object Arguments]";
function b(e) {
  return t(e) && a(e) == i;
}
var o = b;
export {
  o as _
};
